module.exports = __webpack_public_path__ + "static/media/meeting_room.f82cfd6c.jpg";